import { graphql } from '@api/generated';

export const submitUserReportMutation = graphql(`
  mutation submitUserReport($input: UserReportInput!) {
    submitUserReport(input: $input) {
      id
    }
  }
`);
